import React from "react";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import format from "date-fns/format";
import Instructions from "../components/Instructions";
import { ImageAttribution } from "../components/ImageAttribution";

export default function IntroSummary(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>

      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
      />

      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      <ImageAttribution attribution={data.media} tl={tl} dir={dir} />

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={12} className="m-0">
            <Typography
              className="wysiwyg m-0"
              dangerouslySetInnerHTML={{ __html: data.text }}
            />
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}
